import React from 'react'
import Selector from './Selector'
import clsx from 'clsx'
import { Select } from '@material-ui/core'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8

// Custome Prop for material-ui selector
export const withStyleSelector = (SelectorComp) => (props) => {
  const { className, variant, ...rest } = props
  return (
    <SelectorComp
      {...rest}
      className={clsx(className, 'w-full')}
      variant={variant || 'outlined'}
      MenuProps={{
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'center',
        },
        getContentAnchorEl: null,
        PaperProps: {
          style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          },
        },
      }}
    />
  )
}

export const StyleFormSelector = withStyleSelector(Selector)

//Don't sure why when CheckboxTreeFormsy use the StyleSelector, the label is not set.
//Need to investigate further
export const StyleSelect = withStyleSelector(Select)
